import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'reactstrap';
import withTextInput from '../input/withTextInput';
import withUseEffectErrorMessage from '../input/withUseEffectErrorMessage';
import withInputErrorMessage from '../withInputErrorMessage';

const AddressAS = (props) => {
   return (
      <Input
         type={props.type}
         name={props.name}
         onChange={props.onChange}
         onBlur={props.onBlur}
         value={props.isDisabled && props.isValueHiddenWhenDisabled ? '' : props.value}
         disabled={props.isDisabled}
         className={props.className}
      />
   );
};

AddressAS.propTypes = {
   name: PropTypes.string.isRequired,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   isValueHiddenWhenDisabled: PropTypes.bool,
   className: PropTypes.string,
   type: PropTypes.string,
};

AddressAS.defaultProps = {
   value: '',
   isDisabled: false,
   isValueHiddenWhenDisabled: false,
   className: '',
   type: 'text',
};


export default withUseEffectErrorMessage(withTextInput(withInputErrorMessage(AddressAS)));
